<template>
    <div class="box">
        <div class="main">
            <div class="title">
                <ul>
                    <li v-for="item in articleList" :key="item.id">
                        <router-link :to="{ name: 'Article', params: { id: item.id } }">{{ item?.title }}</router-link>
                    </li>
                    <!-- <li><a href="/#/article/38">注册协议</a></li>
                    <li><a href="/#/article/42">信息审核机制</a></li> -->
                </ul>
                <p>客服热线：{{ system?.system_phone }}</p>
            </div>

            <div class="type">
                <div class="type-items">
                    <div class="type-item" @mouseenter="hover(index)" :class="{ active: active == index }" v-for="(item, index) in typeList" :key="item.id">
                        <span @click="$router.push({ name: 'Type', params: { id: item.id } })">{{ item.type_name }}</span>
                    </div>
                </div>
                <div class="list">
                    <ul>
                        <li v-for="it in childType" :key="it.id">
                            <router-link :to="{ name: 'Type', params: { id: it.id } }">{{ it?.type_name }}</router-link>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="icp">
                <p>{{ system?.system_copyright }}</p>
                <p>
                    备案号： <a href="https://beian.miit.gov.cn/">{{ system?.system_icp }}</a>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { reqGetArticleHome } from '@/api';
import route from '@/router/route';
import { mapState } from 'vuex';
export default {
    name: 'Footer',
    data() {
        return {
            articleList: [],
            active: 0,
            childType: [],
        };
    },
    computed: {
        ...mapState('system', ['system']),
        ...mapState('types', ['typeList']),
    },
    created() {
        this.init();
    },
    methods: {
        hover(index) {
            this.active = index;
            // this.getActiveType(index);
        },
        // getActiveType(index) {
        //     this.childType = this.typeList[index].children;
        // },
        async init() {
            const data = await reqGetArticleHome();
            if (data.code == 200) {
                this.articleList = data.data;
                // this.getActiveType(this.active);
            }
        },
    },
    components: { route },
};
</script>

<style lang="less" scoped>
.box {
    background-color: #222222;
    padding-bottom: 50px;
    background: url('@/assets/footer-bg.jpg') no-repeat center top #222;
    .main {
        .title {
            height: 76px;
            border-bottom: 1px solid #393939;
            line-height: 75px;
            display: flex;
            justify-content: space-between;
            ul {
                display: flex;
                gap: 30px;
                li {
                    a {
                        color: #fff;
                    }
                }
            }
            p {
                color: #7dcfa0;
                font-size: 14px;
            }
        }
        .type {
            padding: 13px 0 20px 0;
            border-bottom: 1px solid #393939;
            .active {
                span {
                    background: #394043 !important;
                    color: #fff !important;
                }
            }
            .type-items {
                display: flex;
                gap: 30px;
                span {
                    background: #121212;
                    padding: 8px 10px;
                    display: inline-block;
                    font-size: 12px;
                    color: #888c8e;
                    cursor: pointer;
                    transition: all 0.3s;
                    &:hover {
                        background: #394043;
                        color: #fff;
                    }
                }
            }
            .list {
                margin-top: 20px;
                ul {
                    display: flex;
                    gap: 20px;
                    li {
                        a {
                            color: #888c8e;
                            font-size: 12px;
                        }
                    }
                }
            }
        }
        .icp {
            margin-top: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            p {
                color: #fff;
            }
        }
    }
}
</style>
